import ROUTES from '../SalesReportContainer/reportRoutes';
import { createProductServiceSalesHashLink } from '../common/createProductServiceSalesNavLink';

export default createProductServiceSalesHashLink({
  route: ROUTES.PRODUCT_SALES_REPORT,
  includeChannel: false,
  displayName: 'ProductSalesLink',
  getOnClickArgs: ({ fromDate, toDate, employeeFilter }) => [fromDate, toDate, employeeFilter],
});
